import { useAxiosMutation } from './use-axios.hook';
import { sendContactMessage } from '../../api/contact.api';
import { SendContactMessageApiRequest } from '../../../../types/requests/contact/send-contact-message.request';

export const useSendContactMessage = () => {
  const [request, { data, ...result }] = useAxiosMutation({
    mutationFn: async (params: SendContactMessageApiRequest) => (await sendContactMessage(params)).data,
  });
  return [request, result] as const;
};
